"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Directanswerblock() {
  const {
    ref: indexRef,
    isVisible: indexVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: manifestoRef,
    isVisible: manifestoVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const {
    ref: ruleRef,
    isVisible: ruleVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const manifestoLines = [{
    text: "We believe every industrial label",
    italicWord: ""
  }, {
    text: "should be built to ",
    italicWord: "endure."
  }, {
    text: "Not faded. Not brittle. Not failing.",
    italicWord: ""
  }, {
    text: "The mark should be deep, the material should be resilient,",
    italicWord: ""
  }, {
    text: "and the precision should be absolute — exactly as ",
    italicWord: "specified."
  }];
  return <section data-section-id="1604" id="directanswerblock" className="bg-background text-foreground relative overflow-hidden py-44 md:py-56">
      {}
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 flex items-center justify-end pr-[5vw] md:pr-[8vw]">
        <span className="font-default select-none leading-none" style={{
        fontSize: "32vw",
        fontWeight: 100,
        color: "var(--primary)",
        opacity: 0.08,
        WebkitTextStroke: "1px var(--primary)",
        letterSpacing: "-0.05em"
      }}>
          01
        </span>
      </div>

      <div className="relative mx-auto w-full max-w-4xl px-6 md:px-8">
        {}
        <div ref={indexRef} className={`transition-all duration-700 ease-out ${indexVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
        transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
      }}>
          <p className="font-mono uppercase text-primary" style={{
          fontSize: "clamp(0.6875rem, 0.78vw, 0.8125rem)",
          letterSpacing: "0.18em",
          lineHeight: 1
        }}>
            N&deg; 01 &mdash; Our Standard
          </p>
        </div>

        {}
        <div className="h-24 md:h-[120px]" aria-hidden="true" />

        {}
        <div ref={manifestoRef} className="relative">
          <h2 className="font-default text-accent" style={{
          fontSize: "clamp(2.25rem, 5.4vw, 5.5rem)",
          fontWeight: 200,
          letterSpacing: "-0.025em",
          lineHeight: 1.08
        }}>
            {manifestoLines.map((line, i) => <span key={i} data-index={i} className={`block transition-all ease-out ${manifestoVisible ? "translate-y-0 opacity-100" : "translate-y-4 opacity-0"}`} style={{
            transitionDuration: "700ms",
            transitionDelay: `${i * 120}ms`,
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }}>
                {line.text}
                {line.italicWord && <em className="not-italic text-primary" style={{
              fontStyle: "italic",
              fontWeight: 200
            }}>
                    {line.italicWord}
                  </em>}
              </span>)}
          </h2>
        </div>

        {}
        <div className="h-20 md:h-24" aria-hidden="true" />

        {}
        <div ref={ruleRef}>
          <div className="relative w-full" aria-hidden="true">
            <div className="h-px origin-left transition-transform ease-out" style={{
            backgroundColor: "var(--primary)",
            opacity: 0.35,
            transform: ruleVisible ? "scaleX(1)" : "scaleX(0)",
            transitionDuration: "600ms",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }} />
            {}
            <span className={`absolute -top-[2.5px] right-0 block size-[6px] transition-opacity ${ruleVisible ? "opacity-100" : "opacity-0"}`} style={{
            backgroundColor: "var(--primary)",
            transitionDuration: "300ms",
            transitionDelay: "650ms"
          }} />
          </div>

          <div className="mt-8 md:mt-10">
            <p className={`font-mono uppercase text-foreground/60 transition-all ease-out ${ruleVisible ? "translate-y-0 opacity-100" : "translate-y-2 opacity-0"}`} style={{
            fontSize: "clamp(0.6875rem, 0.75vw, 0.75rem)",
            letterSpacing: "0.08em",
            lineHeight: 1.4,
            transitionDuration: "500ms",
            transitionDelay: "750ms",
            transitionTimingFunction: "cubic-bezier(0.22, 1, 0.36, 1)"
          }}>
              Established by Precision Engraving Labs &middot; Industrial Marking Experts &middot; 2012
            </p>
          </div>
        </div>
      </div>
    </section>;
}